import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Poland",
  "use": "Poland-usage",
  "viewBox": "0 0 193.16 45.05",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 193.16 45.05\" id=\"Poland\"><defs><style>#Poland .cls-1{fill:#fff;}#Poland .cls-2{fill:#ed1849;}</style></defs><polygon class=\"cls-1\" points=\"0 45.05 15.95 0 193.16 0 177.22 45.05 0 45.05\" /><polygon class=\"cls-2\" points=\"0 45.05 7.98 22.52 185.19 22.52 177.22 45.05 0 45.05\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol